import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService, serializeIncludes } from '@mode/shared/util-halogen';
import { map, Observable } from 'rxjs';
import { DataRunResource, EmbeddedDataRunsResponse } from './data-run-response.types';
import { Includes } from 'libs/shared/contract-common/src/lib/mode-api';

@Injectable({ providedIn: 'root' })
export class DataRunClientService {
  constructor(private http: HttpClient) {}

  public loadDataRuns(
    accountToken: string,
    reportToken: string,
    reportRunToken: string,
    includes?: Includes
  ): Observable<DataRunResource[]> {
    const dataRunsUrl = `/api/${accountToken}/reports/${reportToken}/runs/${reportRunToken}/data_runs`;
    const includeParams = includes ? serializeIncludes(includes) : {};
    return this.http
      .get<EmbeddedDataRunsResponse>(dataRunsUrl, {
        params: includeParams,
      })
      .pipe(
        map((response) => {
          return response._embedded.data_runs;
        })
      );
  }
}
